// extracted by mini-css-extract-plugin
export default {"availabilityText":"ExtendedDeskBookingAction_availabilityText__ok1HM","availabilityContainer":"ExtendedDeskBookingAction_availabilityContainer__dGuio"};